/**
 * Extract a human-readable message from an unknown thrown value.
 *
 * React Query hands the value a queryFn/mutationFn threw back as `error: unknown`.
 * Rendering it with `String(error)` calls Error.prototype.toString, which prefixes
 * the Error subclass name — so an `ApiError` surfaces to users as
 * "ApiError: not found", leaking an internal class name into the UI. This returns
 * just the message text for Error instances, with sensible fallbacks for the rare
 * non-Error throwable or an Error with an empty message.
 */
export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message || error.name;
  if (typeof error === 'string') return error;
  if (error == null) return 'Unknown error';
  return String(error);
}
